import React from 'react';
import {Link} from "react-router-dom";
import {getTranslation} from "../../translations";

// Catches render errors in the routed page so Menu and Footer stay mounted.
// `lang` comes as a prop: reading LangContext here would import App.js from a module App.js
// itself imports. `resetKey` (the pathname) clears the error on navigation without remounting
// healthy pages on every route change.
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError() {
        return {hasError: true};
    }

    componentDidCatch(error, info) {
        console.error('Page crashed:', error, info?.componentStack);
    }

    componentDidUpdate(prevProps) {
        if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
            this.setState({hasError: false});
        }
    }

    render() {
        if (!this.state.hasError) return this.props.children;
        const lang = this.props.lang || 'en';
        return (
            <div className='error-boundary center-wrapper flex-column py-5'>
                <h1>{getTranslation(lang, 'pageErrorTitle')}</h1>
                <Link to={`/${lang}`}>{getTranslation(lang, 'backToHome')}</Link>
            </div>
        );
    }
}

export default ErrorBoundary;
